import { Button, Form, InputNumber, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import EditableTable from '../components/EditableTable';


const columns = [
  {
    title: 'To',
    dataIndex: 'destination_location',
    editable: true,
    width: '44%'
  },
  {
    title: 'Destination Package',
    dataIndex: 'destination_package_id',
    editable: true,
    width: '44%'
  },
  {
    title: 'Done',
    dataIndex: 'done_quantity',
    editable: true,
    width: '44%'
  },
  {
    title: ''
  }
]


const MyFooter = ({ handleSaveNew, handleSaveClose, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveNew} type='primary'>Save and New</Button>
      <Button className='me-3' onClick={handleSaveClose} type='primary'>Save and Close</Button>
      <Button onClick={handleCancel} danger>Discard</Button>
    </div>
  )
};

const DetailedOperationModal = ({locations, operations, setRules, rules}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [detailedOperations, setDetailedOperations] = useState([]);

  const handleCancel = () => setIsModalOpen(false);
  

  const handleSaveNew = () => {
    // addEntry();
    save();
    
  };

  const addEntry = () => { 
    let ops = [...detailedOperations]
    let entryObj = {
      key: detailedOperations.length + 1,
      destination_location: '',
      destination_package: '',
      done_quantity: ''
    }
    ops.push(entryObj);
    setDetailedOperations(ops);
    // form.setFieldsValue({ ...entryObj })
  }

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...detailedOperations];
      const index = newData.findIndex((item) => key === item.key)
      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...row })
        console.log(newData)
        setDetailedOperations(newData)
      }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }

  

  useEffect(() => {
    EventEmitter.subscribe('show_detailed_operation_modal', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('show_detailed_operation_modal');
  },[])

  const handleSaveClose = () => {
    save();
    handleCancel();
  }



  return (
    <Modal title="Detailed Operations" className='p-0' width={'700px'} open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSaveNew={handleSaveNew} handleSaveClose={handleSaveClose}/>}>
      <Form 
        form={form}
        className='pt-2 border-t-2' 
        labelAlign='left'
        labelCol={{span: 5}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='Product' name="product_id" className='font-semibold text-gray-800 mb-4' required>
          <Select options={[]} className='font-normal'/>
        </Form.Item>
        <Form.Item label='Demand' name="demand_quantity" className='font-semibold text-gray-800 mb-4' required>
          <InputNumber className='font-normal w-full' />
        </Form.Item>
        <Form.Item label='Quantity Done' name="quantity_done" className='font-semibold text-gray-800 mb-4' required>
          <InputNumber className='font-normal w-full' />
        </Form.Item>
        <EditableTable
          columns={columns}
          dataSource={detailedOperations}
          setDataSource={setDetailedOperations}
          addLine={addEntry}
          option1={[]}
          option2={[]}
        />
      </Form>
    </Modal>
  )
}

export default DetailedOperationModal;